import { render, staticRenderFns } from "./CampaignItem.vue?vue&type=template&id=beb7c6b2&scoped=true&"
import script from "./CampaignItem.vue?vue&type=script&lang=ts&"
export * from "./CampaignItem.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignItem.vue?vue&type=style&index=0&id=beb7c6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb7c6b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beb7c6b2')) {
      api.createRecord('beb7c6b2', component.options)
    } else {
      api.reload('beb7c6b2', component.options)
    }
    module.hot.accept("./CampaignItem.vue?vue&type=template&id=beb7c6b2&scoped=true&", function () {
      api.rerender('beb7c6b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CampaignItem.vue"
export default component.exports